import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useNavigate } from '@tanstack/router'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'
import { css } from '@linaria/core'

import useDimensions from '../../hooks/useDimensions'
import { useBoundStore } from '../../store/store'
import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Icon from '../icon'
import WalletManagementModal from '../wallet-management/wallet-management-modal'

const container = css`
  @media (min-width: 1200px) {
    max-width: 450px;
  }
`

const Title = styled.h3`
  font-family: 'Avenir-Black';
  font-size: 20px;
  color: var(--txt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  svg {
    margin-right: 10px;
  }
  @media (min-width: 1200px) {
    font-size: 24px;
    svg {
      width: 35px;
      height: 35px;
    }
  }
`

const Text = styled.p`
  font-family: 'Avenir-Light';
  font-size: 15px;
  color: var(--txt);
  text-align: center;
  margin-bottom: 24px;
  @media (min-width: 1200px) {
    font-size: 17px;
  }
`

const Proceed = styled.button`
  text-align: center;
  font-size: 18px;
  width: max-content;
  padding: 7px 36px;
  background-color: var(--ok-btn-bg);
  border: 1.5px solid var(--ok-btn-bg);
  color: var(--ok-btn-txt);
  border-radius: 22px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  font-family: 'Avenir-Light';
  margin: 0 auto;
  display: block;
  @media (min-width: 1200px) {
    font-size: 20px;
    padding: 10px 0;
    width: 170px;
    border-radius: 26px;
  }
`

const PendingDepositModal = () => {
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const modal = useModal()
  const walletManagementModal = useModal(WalletManagementModal)
  const { t } = useTranslation(['common', 'walletManagement'])
  const navigate = useNavigate()
  const { isDesktop } = useDimensions()

  const handleClick = async () => {
    await closeModal(modal)
    if (isDesktop) {
      walletManagementModal.show({
        walletManagementDefaultTab: {
          tab: 0,
          page: +pending_bind === 0 ? 1 : 2,
        },
      })
    } else {
      navigate({
        to: +pending_bind === 0 ? '/kyc-bank' : '/kyc-bank-list',
        search: {
          method: 'deposit',
        },
      })
    }
  }

  return (
    <Modal id="pending-deposit-modal" containerStyle={container}>
      <Title>
        <Icon id="exclamation-circle" width="30" height="30" />
        {t('unable-to-play', { ns: 'walletManagement' })}
      </Title>
      <Text>{t('fulfill-deposit', { ns: 'walletManagement' })}</Text>
      <Proceed onClick={handleClick}>{t('ok', { ns: 'common' })}</Proceed>
    </Modal>
  )
}

export default NiceModal.create(PendingDepositModal)
